import AccordionInteraction from './accordions'
import NavigationHandler from './navigation'
import ShowHideInteraction from './showHide'
import handleInputs from './handleInputs'
import handleValueLogic from './handleValueLogic'
import initMoneyMask from './maskMoney'
import initAppendMonths from './appendMonth'

export default function contentInteractions(
  node: HTMLElement,
  language: string,
  setIsRebuttals: React.Dispatch<React.SetStateAction<boolean>>,
  setIsScripts: React.Dispatch<React.SetStateAction<boolean>>,
  setCurrentScript: React.Dispatch<React.SetStateAction<number>>,
  setCurrentRebuttal: React.Dispatch<React.SetStateAction<number>>,
  textInputCallback: (_e: Event) => void,
  clickInputCallback: (_e: Event) => void,
  clickCalendarCallback: (_e: Event) => void,
  selectInputCallback: (_e: Event) => void,
  booleanInputCallback: (_e: Event) => void,
): void {
  AccordionInteraction(node)
  ShowHideInteraction(node)
  handleInputs(
    node,
    (e) => {
      textInputCallback(e)
    },
    (e) => {
      clickInputCallback(e)
    },
    (e) => {
      clickCalendarCallback(e)
    },
    (e) => {
      selectInputCallback(e)
    },
    (e) => {
      booleanInputCallback(e)
    },
  )
  handleValueLogic(node)
  NavigationHandler({
    node,
    setIsRebuttals,
    setIsScripts,
    setCurrentScript,
    setCurrentRebuttal,
  })
  initMoneyMask(node)
  initAppendMonths(node, language)
}
